import { Note } from "@app/models/note.model";
import { ScheduleConfig } from "@app/models/schedule.model";

export class FetchDailyScheduleList {
    static readonly type = '[Schedule] Fetch daily schedule list';
    constructor(public date?: Date) { }
}
export class GetScheduleList {
    static readonly type = '[Schedule] Get schedule list';
    constructor(public stfcd: string, public sdate: Date, public edate: Date, public skip?: number) { }
}
export class GetScheduleTimeLineList {
    static readonly type = '[Schedule] Get schedule timeline list';
    constructor(public stfcd: string, public sdate: Date, public edate: Date, public skip?: number, public roleKey: string = "", public roleContents: string[] = []) { }
}
export class SetScheduleResult {
    static readonly type = '[Schedule] Set schedule result';
    constructor(public note: Note) { }
}
export class SetCurrentDate {
    static readonly type = '[Schedule] Set Current Date';
    constructor(public currentDate: Date) { }
}

export class GetScheduleConfig {
    static readonly type = '[Schedule] Get Filter';
    constructor() { }
}

export class ResetScheduleFilter {
    static readonly type = '[Schedule] Reset Filter';
    constructor() { }
}

export class SetScheduleConfig {
    static readonly type = '[Schedule] Set Filter';
    constructor(public config: ScheduleConfig) { }
}
export class SetScheduleConfigRole {
    static readonly type = '[Schedule] Set Role';
    constructor(public sched_add: boolean[], public sched_view: boolean[]) { }
}

export class ResetSchedule {
    static readonly type = '[Schedule] Clean';
}

export class AddSchedules {
    static readonly type = '[Schedule] Add';
    constructor(public schedules: any[]) { }
}

export class TriggerHistory {
    static readonly type = '[History] Fetch';
    constructor() { }
}

export class UpdateConfigOpenState {
    static readonly type = '[Config] Open Config';
    constructor(public open: boolean) { }
}

export class SetVisibleOnlyData {
    static readonly type = '[Schedule] Set Visible';
    constructor(public id: string) { }
}

export class RemoveVisibleOnlyData {
    static readonly type = '[Schedule] Remove Visible';
    constructor(public id?: string) { }
}

export class SetExistingFilter {
    static readonly type = '[Schedule] SetExistingFilter';
    constructor(public existingFilter: boolean) { }
}